import { LuShoppingCart, LuUndo2, LuReceipt } from "react-icons/lu";
import {
    SalesOrderData,
    SalesOrderCreate,
    SalesOrderEdit,
    SalesOrderDetail,
    SalesOrderPrint,
    SalesOrderPrintBill,
} from "@/pages/sales-order";
import {
    SalesOrderReturnData,
    SalesOrderReturnCreate,
    SalesOrderReturnDetail,
    SalesOrderReturnPrint,
} from "@/pages/sales-order-return";
import {
    SalesPaymentData,
    SalesPaymentCreate,
    SalesPaymentDetail,
    SalesPaymentPrint,
} from "@/pages/sales-payment";

export const salesPrintRoutes = [
    {
        path: "/sales-order/:id/print",
        component: <SalesOrderPrint />,
        permission: "sales-order.view",
    },
    {
        path: "/sales-order/:id/print-bill",
        component: <SalesOrderPrintBill />,
        permission: "sales-order.view",
    },
    {
        path: "/sales/return/:id/print",
        component: <SalesOrderReturnPrint />,
        permission: "sales-order-return.view",
    },
    {
        path: "/sales-payment/:id/print",
        component: <SalesPaymentPrint />,
        permission: "sales-payment.view",
    },
];

export const salesRoutes = {
    title: "PENJUALAN",
    type: "section",
    items: [
        {
            path: "/sales-order",
            title: "Penjualan",
            icon: <LuShoppingCart />,
            permission: "sales-order.view",
            children: [
                {
                    path: "/sales-order",
                    title: "Daftar Sales Order",
                    component: <SalesOrderData />,
                },
                {
                    path: "/sales-order/create",
                    title: "Tambah Sales Order",
                    component: <SalesOrderCreate />,
                    permission: "sales-order.create",
                    type: "hidden",
                },
                {
                    path: "/sales-order/:id/edit",
                    title: "Edit Sales Order",
                    component: <SalesOrderEdit />,
                    permission: "sales-order.edit",
                    type: "hidden",
                },
                {
                    path: "/sales-order/:id/detail",
                    title: "Detail Sales Order",
                    component: <SalesOrderDetail />,
                    permission: "sales-order.view",
                    type: "hidden",
                },
            ],
        },
        {
            path: "/sales/return",
            title: "Retur Penjualan",
            icon: <LuUndo2 />,
            permission: "sales-order-return.view",
            children: [
                {
                    path: "/sales/return",
                    title: "Daftar Retur",
                    component: <SalesOrderReturnData />,
                },
                {
                    path: "/sales/return/create",
                    title: "Buat Retur",
                    component: <SalesOrderReturnCreate />,
                    permission: "sales-order-return.create",
                    type: "hidden",
                },
                {
                    path: "/sales/return/:id/edit",
                    title: "Edit Retur",
                    component: <SalesOrderReturnCreate />,
                    permission: "sales-order-return.edit",
                    type: "hidden",
                },
                {
                    path: "/sales/return/:id/detail",
                    title: "Detail Retur Penjualan",
                    component: <SalesOrderReturnDetail />,
                    permission: "sales-order-return.view",
                    type: "hidden",
                },
            ],
        },
        {
            path: "/sales-payment",
            title: "Pembayaran Penjualan",
            icon: <LuReceipt />,
            permission: "sales-payment.view",
            children: [
                {
                    path: "/sales-payment",
                    title: "Daftar Pembayaran",
                    component: <SalesPaymentData />,
                },
                {
                    path: "/sales-payment/create",
                    title: "Buat Pembayaran Penjualan",
                    component: <SalesPaymentCreate />,
                    permission: "sales-payment.create",
                    type: "hidden",
                },
                {
                    path: "/sales-payment/:id/edit",
                    title: "Edit Pembayaran Penjualan",
                    component: <SalesPaymentCreate />,
                    permission: "sales-payment.edit",
                    type: "hidden",
                },
                {
                    path: "/sales-payment/:id/detail",
                    title: "Detail Pembayaran Penjualan",
                    component: <SalesPaymentDetail />,
                    permission: "sales-payment.view",
                    type: "hidden",
                },
            ],
        },
    ],
};
